import React from 'react';
import Footer from '../../global/components/footer/footer.components';
import PrivatePage from '../../global/templates/private/privatePage.component';
import {
  Container,
  HeaderTitle,
  ItemButton,
  ItemBox,
  ItemLabels,
  ListBoxHeader,
  ListItemBox,
  Title,
  ProfilePhoto,
  StatusBullet,
  HeaderTitleBox,
  Row,
  PaginationButton,
  PaginationBox,
  PaginationPage,
  PaginationPageActive,
} from './users.styles';
import ButtonSecondary from '../../global/components/buttons/secondary/buttonSecondary.component';
import { IUsersLayoutProps } from './users.types';
import ButtonFilter from '../../global/components/buttons/buttonFilter/buttonFilter.component';
import Loading from '../../global/components/loading/loading.component';

const UsersLayout: React.FC<IUsersLayoutProps> = ({ localState, handlers }) => {

  const {
    users,
    loading
  } = localState;
  const {
    handleRegister,
    handleEdit,
    handleAskDeleteUser
  } = handlers;
  return (
    <PrivatePage>
      <Container>
        <HeaderTitleBox>
          <Title>Usuários e permissões de acesso</Title>
          <Row>
            <ButtonSecondary
              label='Cadastrar novo usuário'
              isDisabled={false}
              loading={false}
              onClick={handleRegister}
            />
            {/* <ButtonFilter
              onClick={() => { }}
            /> */}
          </Row>
        </HeaderTitleBox>

        <ListBoxHeader>
          <HeaderTitle size={3}>Nome</HeaderTitle>
          <HeaderTitle size={2}>Email</HeaderTitle>
          <HeaderTitle size={1}>Status</HeaderTitle>
          <HeaderTitle size={2}>Último acesso</HeaderTitle>
          <HeaderTitle size={1}>Editar</HeaderTitle>
          <HeaderTitle size={1}>Excluir</HeaderTitle>
        </ListBoxHeader>

        {loading.status ?
          <Loading label='usuários' />
          :
          <>
            {users.map((item, index) => <ListItemBox key={index}>
              <ItemLabels size={3} customStyle={{
                'justify-content': 'flex-start;'
              }}>
                <ProfilePhoto
                  src={item.thumb}
                  alt='user-photo'
                />
                {item.fullname}
              </ItemLabels>
              <ItemLabels size={2}>{item.email}</ItemLabels>
              <ItemLabels size={1}>
                <StatusBullet active={item.active} />
                {item.active ? 'Ativo' : 'Inativo'}
              </ItemLabels>
              <ItemLabels size={2}>{item.lastLogin}</ItemLabels>
              <ItemBox size={1}>
                <ItemButton onClick={() => handleEdit(item)}>
                  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.158203 20.8425H18.6857V22.0001H0.158203V20.8425Z" fill="#99A5B6" />
                    <path d="M19.081 1.99003L17.8528 0.761906C16.8375 -0.253457 15.1838 -0.25448 14.1684 0.761906L3.11384 11.8152C3.04425 11.8848 2.99347 11.9714 2.96667 12.0658L1.32881 17.7977C1.2712 18.0006 1.32781 18.2174 1.47598 18.3666C1.58635 18.4769 1.73353 18.5365 1.88569 18.5365C1.93847 18.5365 1.99207 18.5295 2.04485 18.5147L7.77672 16.8769C7.87212 16.8501 7.95769 16.7993 8.02728 16.7297L19.0806 5.67466C19.5729 5.18236 19.8444 4.52811 19.8444 3.83286C19.8443 3.1368 19.5727 2.48136 19.0806 1.99025L19.081 1.99003ZM7.31462 15.803L2.7292 17.1127L4.03889 12.5272L12.9391 3.62576L16.2148 6.90144L7.31462 15.803ZM18.2627 4.85618L17.0346 6.0843L13.7589 2.80862L14.987 1.5805C15.5508 1.01664 16.4697 1.01664 17.0346 1.5805L18.2627 2.80862C18.5362 3.08215 18.6864 3.44509 18.6864 3.83199C18.6864 4.21873 18.5362 4.58265 18.2627 4.85618Z" fill="#99A5B6" />
                  </svg>
                </ItemButton>
              </ItemBox>
              <ItemBox size={1}>
                <ItemButton onClick={() => handleAskDeleteUser(item)}>
                  <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.4982 3.35459H14.6164L14.3106 2.52873C14.1605 2.12413 13.9036 1.79526 13.5777 1.5699C13.2534 1.34529 12.8539 1.21957 12.4179 1.21957H8.5766C8.14085 1.21957 7.74113 1.34548 7.4168 1.5699C7.09096 1.79525 6.83419 2.1241 6.68394 2.52873L6.37808 3.35459H10.4982ZM8.108 19.9415C8.108 20.2775 7.83275 20.5507 7.49401 20.5507C7.15528 20.5507 6.88002 20.2776 6.88002 19.9415V18.5549C6.88002 18.2188 7.15528 17.9457 7.49401 17.9457C7.83347 17.9457 8.108 18.2188 8.108 18.5549V19.9415ZM8.108 15.2013C8.108 15.5382 7.83275 15.8106 7.49401 15.8106C7.15528 15.8106 6.88002 15.5374 6.88002 15.2013V9.27402C6.88002 8.93795 7.15528 8.6648 7.49401 8.6648C7.83347 8.6648 8.108 8.93792 8.108 9.27402V15.2013ZM15.9229 3.35431H18.7473C19.1719 3.35431 19.5692 3.46503 19.9128 3.67131C20.2531 3.87519 20.5364 4.17388 20.7354 4.54903L20.7361 4.54829C20.9336 4.92252 21.0201 5.32324 20.9961 5.71892C20.972 6.11555 20.838 6.50254 20.5963 6.85048L19.8363 7.94388C19.7745 8.03313 19.7295 8.12312 19.6998 8.21701C19.6717 8.307 19.658 8.40736 19.658 8.51957V21.2919C19.658 22.5875 19.1243 23.7647 18.2648 24.6175C17.4052 25.4704 16.2181 26 14.9131 26H6.0869C4.7819 26 3.59482 25.4704 2.73527 24.6175C1.87572 23.7647 1.34199 22.5868 1.34199 21.2919V8.51957C1.34199 8.40736 1.32837 8.307 1.30019 8.21701C1.27052 8.1222 1.22554 8.03313 1.16377 7.94388L0.403685 6.85048C0.161271 6.50255 0.0272792 6.11464 0.00395119 5.71892C-0.0201226 5.32302 0.0657225 4.92249 0.263908 4.54829L0.284809 4.51163C0.482249 4.15333 0.758259 3.86889 1.08746 3.6706C1.43009 3.46506 1.82738 3.35359 2.2529 3.35359H5.07735L5.5381 2.10888C5.77567 1.46784 6.19069 0.941381 6.72108 0.574196C7.25314 0.205526 7.89379 0 8.58144 0H12.4228C13.1106 0 13.7511 0.205536 14.2831 0.574196C14.8136 0.941386 15.2295 1.46784 15.4661 2.10888L15.9269 3.35359L15.9229 3.35431ZM12.8883 9.27402C12.8883 8.93795 13.1635 8.6648 13.5023 8.6648C13.841 8.6648 14.1162 8.93792 14.1162 9.27402V10.6606C14.1162 10.9966 13.841 11.2698 13.5023 11.2698C13.1628 11.2698 12.8883 10.9967 12.8883 10.6606V9.27402ZM12.8883 14.0142C12.8883 13.6781 13.1635 13.4049 13.5023 13.4049C13.841 13.4049 14.1162 13.6781 14.1162 14.0142V19.9415C14.1162 20.2775 13.841 20.5507 13.5023 20.5507C13.1628 20.5507 12.8883 20.2776 12.8883 19.9415V14.0142ZM18.7463 4.57333H2.24853C2.05035 4.57333 1.86895 4.62277 1.71647 4.7135C1.57035 4.80109 1.44756 4.92774 1.3578 5.08698L1.34417 5.11494C1.25273 5.28771 1.21261 5.4701 1.22381 5.64766C1.23426 5.8245 1.29603 6.00041 1.40763 6.16057L2.16847 7.25397C2.3034 7.44747 2.40212 7.64653 2.46781 7.85594C2.53518 8.06944 2.56727 8.28924 2.56727 8.52016V21.2925C2.56727 22.2513 2.9629 23.1242 3.60096 23.7565C4.23826 24.3889 5.11797 24.7822 6.08424 24.7822H14.9105C15.8768 24.7822 16.7565 24.3896 17.3938 23.7565C18.0311 23.1242 18.4275 22.2513 18.4275 21.2925V8.52016C18.4275 8.28925 18.4603 8.06946 18.5269 7.85594C18.5928 7.64652 18.6923 7.44746 18.8263 7.25397L19.5871 6.16057C19.6987 5.99966 19.7605 5.82449 19.7709 5.64766C19.7821 5.47082 19.742 5.28844 19.6506 5.11494L19.6522 5.1142L19.6506 5.11254C19.5599 4.94126 19.4322 4.8059 19.2781 4.71443C19.1263 4.62277 18.9449 4.57425 18.746 4.57425L18.7463 4.57333Z" fill="#99A5B6" />
                  </svg>
                </ItemButton>
              </ItemBox>
            </ListItemBox>)}

            <PaginationBox>
              <PaginationButton>
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 1L1 6L6 11" stroke="#1B2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </PaginationButton>

              {[''].map((item, index) => {
                if (index === 0)
                  return (
                    <PaginationPageActive key={index} disabled={true}>
                      {index + 1}
                    </PaginationPageActive>
                  )
                else
                  return (
                    <PaginationPage key={index}>
                      {index + 1}
                    </PaginationPage>
                  )

              })}
              <PaginationButton>
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 6L1 11" stroke="#1B2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </PaginationButton>
            </PaginationBox>
          </>
        }



      </Container>
      <Footer />
    </PrivatePage>
  )
}

export default UsersLayout;